<template>
  <div class="app-container">
    <div class="top-container">
      <p>{{ currCustomer.customerName }}</p>
      <p>{{ currCustomer.operationAddress }}</p>
      <p>电话：{{ currCustomer.contactTel }}</p>
    </div>

    <el-tabs v-model="activeName" class="tabs-wrap" @tab-click="handleClick">
      <el-tab-pane label="管理员工" name="user">
        <User />
      </el-tab-pane>
      <el-tab-pane v-if="!isPermissionDisabled('DCP-DP-P')" label="门店照片" name="StoreImage">
        <StoreImage />
      </el-tab-pane>
      <el-tab-pane v-if="!isPermissionDisabled('DCP-DL-P')" label="门店位置" name="location">
        <Location />
      </el-tab-pane>
      <el-tab-pane v-if="!isPermissionDisabled('DCP-SI-P')" label="服务项目" name="service">
        <Service />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import User from './components/User'
import StoreImage from './components/StoreImage'
import Location from './components/Location'
import Service from './components/Service'

export default {
  name: 'Setting',
  components: { User, StoreImage, Location, Service },
  data() {
    return {
      loadingComponent: null,
      isLoading: false,
      activeName: 'user'
    }
  },
  computed: {
    currCustomer() {
      return this.$store.getters.currCustomer
    },
    isPermissionDisabled() {
      return function(val) {
        const list = this.$store.getters.currApps.SET || []
        const data = list.filter(item => item.applicationId === val)

        return !data.length
      }
    }
  },
  watch: {
    isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    }
  },
  methods: {
    handleClick() {}
  }
}
</script>

<style lang="scss" scoped>
.top-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 217px;
  padding-bottom: 13px;
  padding-left: 13px;
  margin: 130px 0 0;
  font-size: 24px;
  line-height: 1.6;
  background: url('../../assets/img/user-banner.png') no-repeat;
  background-size: cover;
}

.tabs-wrap {
  /deep/ .el-tabs__header {
    .el-tabs__nav-wrap::after {
      background-color: #fff;
    }

    .el-tabs__active-bar {
      @include background_color_page_primary('color');
    }

    .el-tabs__item {
      height: 60px;
      // font-weight: 300;
      font-size: 14px;
      line-height: 60px;

      &:hover {
        @include color_page_primary('font-color-diff');
      }

      &.is-active {
        font-weight: 600;

        @include color_page_primary('font-color-diff');
      }
    }
  }
}
</style>
